var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMsSymbollockupMssymbol19(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MS-SymbolLockup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 9,
    height: 9,
    fill: "#f25022"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 9,
    height: 9,
    fill: "#00a4ef"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 9,
    height: 9,
    fill: "#7fba00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 9,
    height: 9,
    fill: "#ffb900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsSymbollockupMssymbol19);
export default __webpack_public_path__ + "static/media/ms-symbollockup_mssymbol_19.42b61fa1.svg";
export { ForwardRef as ReactComponent };